import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import throttle from 'lodash.throttle';
import { useEffect, useState } from 'react';
import { MENU_SCROLL_THROTTLE_INTERVAL, HEADER_HEIGHT } from "../constants";
import { useIsMobileMenu } from "./use-is-mobile-menu";
export var useIsMenuScrolled = function useIsMenuScrolled() {
  var isMobileMenu = useIsMobileMenu();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isScrolled = _useState2[0],
    setIsScrolled = _useState2[1];
  useEffect(function () {
    var handleScroll = throttle(function () {
      var _window = window,
        scrollY = _window.scrollY;
      var visibleThreshold = isMobileMenu ? window.innerHeight / 2 : HEADER_HEIGHT / 2;
      setIsScrolled(scrollY >= visibleThreshold);
    }, MENU_SCROLL_THROTTLE_INTERVAL);
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobileMenu]);
  return isScrolled;
};